import { array, partial } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { RoofRefItem, FloorRefItem, FrameRefItem, EwpRefItem, WholeHouseRefItem } from './RefItem';

export const StructuredRefs = partial({
	roof: array(RoofRefItem),
	floor: array(FloorRefItem),
	frame: array(FrameRefItem),
	ewp: array(EwpRefItem),
	wholeHouse: array(WholeHouseRefItem),

	subFloor: iotsUtils.neverDecoder,
	firstFloor: iotsUtils.neverDecoder,
	secondFloor: iotsUtils.neverDecoder,
	flooring: iotsUtils.neverDecoder,
	bor: iotsUtils.neverDecoder,
	lintel: iotsUtils.neverDecoder,
	rafters: iotsUtils.neverDecoder,
	stickFraming: iotsUtils.neverDecoder,
	maxiwall: iotsUtils.neverDecoder,
	maxifloor: iotsUtils.neverDecoder,
	trimJoist: iotsUtils.neverDecoder,
	cassette: iotsUtils.neverDecoder,
});
